import { useState, useEffect } from 'react';
import { useScrollReveal } from '../../../hooks/useScrollReveal';

const testimonials = [
  {
    name: 'Marcos Andrade',
    role: 'Diretor de Marketing | NovaVisão Tech',
    text: 'A Guepardo transformou totalmente nossa presença digital. O crescimento em engajamento e conversões foi além do que esperávamos.',
    rating: 5
  },
  {
    name: 'Juliana Lopes',
    role: 'CEO | Bella Vita Cosméticos',
    text: 'Profissionais rápidos, estratégicos e extremamente criativos. Trabalhar com a Guepardo foi um divisor de águas para nossa marca.',
    rating: 5
  },
  {
    name: 'Rafael Monteiro',
    role: 'Gerente Comercial | Grupo PrimeSolar',
    text: 'A agência entendeu nosso posicionamento como ninguém. Em poucos meses, tivemos resultados que outras equipes não alcançaram em anos.',
    rating: 5
  },
  {
    name: 'Camila Farias',
    role: 'Coordenadora de Comunicação | AgroVale Solutions',
    text: 'A precisão estratégica da Guepardo é impressionante. Eles entregam exatamente o que prometem — e ainda vão além.',
    rating: 5
  },
  {
    name: 'Vinícius Cardoso',
    role: 'Fundador | MaxFitness Studios',
    text: 'Desde o primeiro contato, ficou claro que estávamos lidando com especialistas. Crescemos rápido, com consistência e segurança.',
    rating: 5
  },
  {
    name: 'Larissa Mendes',
    role: 'Diretora Criativa | UrbanLine Moda',
    text: 'A equipe é extremamente qualificada. Design impecável, estratégias inteligentes e resultados sólidos. Recomendo de olhos fechados.',
    rating: 5
  },
  {
    name: 'Eduardo Silva',
    role: 'Gestor de Projetos | InnoBuild Engenharia',
    text: 'A Guepardo elevou nossa marca a um novo patamar. Hoje somos referência no nosso segmento graças ao trabalho deles.',
    rating: 5
  },
  {
    name: 'Samantha Ribeiro',
    role: 'Supervisora de Operações | FarmaPlus Distribuidora',
    text: 'O comprometimento com prazo e qualidade é algo raro no mercado. A Guepardo domina isso como ninguém.',
    rating: 5
  },
  {
    name: 'Henrique Duarte',
    role: 'Proprietário | HD Medical Supplies',
    text: 'Eles não apenas criam campanhas, eles criam estratégias que realmente convertem. Nosso faturamento disparou.',
    rating: 5
  }
];

export function Testimonials() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const titleRef = useScrollReveal();
  const cardRef = useScrollReveal();

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(timer);
  }, []);

  const next = () => {
    setCurrentIndex((prev) => (prev + 1) % testimonials.length);
  };

  const prev = () => {
    setCurrentIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  const goTo = (index: number) => {
    setCurrentIndex(index);
  };

  return (
    <section id="depoimentos" className="py-24 bg-gradient-to-br from-gray-900 via-black to-gray-900 relative overflow-hidden">
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-amber-200 rounded-full filter blur-3xl"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-amber-100 rounded-full filter blur-3xl"></div>
      </div>

      <div className="max-w-5xl mx-auto px-6 relative z-10">
        <div ref={titleRef} className="text-center mb-16 scroll-reveal">
          <h2 className="text-5xl font-black text-white mb-4">Depoimentos</h2>
          <p className="text-xl text-amber-200 font-medium">O que nossos clientes dizem</p>
          <div className="w-24 h-1 bg-gradient-to-r from-amber-200 to-amber-100 mx-auto mt-4"></div>
        </div>

        <div ref={cardRef} className="relative scroll-reveal-scale">
          <div className="bg-white/5 backdrop-blur-sm rounded-3xl p-12 shadow-2xl border border-white/10">
            <div className="flex justify-center mb-6">
              {[...Array(testimonials[currentIndex].rating)].map((_, i) => (
                <i key={i} className="ri-star-fill text-amber-200 text-2xl"></i>
              ))}
            </div>

            <p className="text-white text-xl leading-relaxed mb-8 text-center italic min-h-[120px]">
              "{testimonials[currentIndex].text}"
            </p>

            <div className="text-center">
              <h4 className="text-amber-200 font-bold text-xl">{testimonials[currentIndex].name}</h4>
              <p className="text-gray-400">{testimonials[currentIndex].role}</p>
            </div>
          </div>

          <button
            onClick={prev}
            className="absolute left-0 top-1/2 -translate-y-1/2 -translate-x-4 w-12 h-12 flex items-center justify-center bg-white/10 backdrop-blur-sm rounded-full text-white hover:bg-white/20 transition-all duration-300 cursor-pointer"
            aria-label="Depoimento anterior"
          >
            <i className="ri-arrow-left-s-line text-2xl"></i>
          </button>

          <button
            onClick={next}
            className="absolute right-0 top-1/2 -translate-y-1/2 translate-x-4 w-12 h-12 flex items-center justify-center bg-white/10 backdrop-blur-sm rounded-full text-white hover:bg-white/20 transition-all duration-300 cursor-pointer"
            aria-label="Próximo depoimento"
          >
            <i className="ri-arrow-right-s-line text-2xl"></i>
          </button>
        </div>

        <div className="flex justify-center gap-2 mt-8">
          {testimonials.map((_, index) => (
            <button
              key={index}
              onClick={() => goTo(index)}
              className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
                index === currentIndex ? 'bg-amber-200 w-8' : 'bg-white/30 hover:bg-white/50'
              }`}
              aria-label={`Ir para depoimento ${index + 1}`}
            ></button>
          ))}
        </div>
      </div>
    </section>
  );
}